
import React, { useEffect, useState } from 'react';
import { Modal, Button, Row, Col, Container } from "react-bootstrap";
import EquipmentSelection from '../Common/equipmentSelection';
import MultiSelectCheckBox from '../Common/MultiSelectCheckBox';
import Chart from 'react-google-charts';
import colors from '../utill/colors.json';
import DetailedProdAnalysisCompTbl from '../utill/DetailedProdAnalysisCompTbl';
import DetailedProdAnalysisPlantTbl from '../utill/DetailedProdAnalysisPlantTbl';
import dateTime from '../utill/dateTime';
import '../App.css'
import _, { cloneDeep } from 'lodash';

const AnalysisDetailedProduction = ({
    onApply,
    handleDownloadTableToExcel,
    reasons,
    qualityReason,
    handleOnChnage,
    data, state, onHide,
    setSelectedEquipGroupOption, selectedEquipGroupOption,
    inputData, setInputData,
    selectedEquipOption, setSelectedEquipOption,
    setEquips, equip,
    shiftOption, setShiftOption,
    equips, equipGroups,fromDateLimit }) => {

    const [showChartType, setShowChartType] = useState({})
    const [showChartState, setShowChartState] = useState(false);

    const onChange = (e) => {
        const obj = {}
        obj.name = e.currentTarget.value;
        obj.label = e.currentTarget.options[e.currentTarget.selectedIndex].innerHTML;
        setShowChartType(obj);
    }

    const setSelection = (key, option, equips) => {
        if (key == 'EquipmentGroup') {
            setEquips(equips ? equips : []);
            setSelectedEquipGroupOption(option)
            setSelectedEquipOption([])
        }
        if (key == 'Equipment') {

            setSelectedEquipOption(option)
        }
    }




    const organiseDowntimeData = (bufferArr) => {
         bufferArr = _.cloneDeep(bufferArr);
        bufferArr = [...getComponentUniqe(bufferArr)]
        let schema = ['Component/Operation']
        let arr = [];
        let colorWithReason = []
        let seriesObj = {}
        bufferArr.forEach(element => {
            element.Downtime.forEach((one, i) => {
                let IsAlready;
                let obj = {}

                if (one.DowntimeReason) {

                    IsAlready = schema.includes(one.DowntimeReason);
                } else {

                    IsAlready = schema.includes(one.State);
                }
                if (!IsAlready) {
                    if (one.DowntimeReason) {
                        obj.Reason = one.DowntimeReason;
                        obj.Color = one.Color;
                        colorWithReason.push(obj)
                        schema.push(one.DowntimeReason)
                        schema.push({ role: 'style' })
                    } else {
                        obj.Reason = one.State;
                        obj.Color = 'red';
                        colorWithReason.push(obj)
                        schema.push(one.State)
                        schema.push({ role: 'style' })
                    }
                }
            })
        });

        bufferArr.forEach(element => {
            let oneArr = []
            if (element.Downtime.length > 0) {
                oneArr = [element.Component + "/" + element.Operation]
            }
            let down = element.Downtime;
            if (down.length > 0) {
                down = aggreagteReasonDowntime(down)
                for (let i = 1; i < schema.length; i = i + 2) {
                    let filterDown = down.filter((one) => {
                        if (one.DowntimeReason) {
                            if (one.DowntimeReason == schema[i]) {
                                return one
                            }
                        } else {
                            if (one.State == schema[i]) {
                                return one
                            }
                        }
                    }
                    )
                    if (filterDown.length > 0) {
                        oneArr.push(Math.ceil(filterDown[0].Duration));
                        oneArr.push(filterDown[0].Color)
                    } else {
                        let filterColor = colorWithReason.filter(color => color.Reason == schema[i])
                        oneArr.push(0);
                        oneArr.push(filterColor[0].Color)
                    }
                }
                arr.push(oneArr)
            }

        })
        arr.unshift(schema)
        colorWithReason.forEach((one, i) => {
            seriesObj[i] = { color: one.Color }
        })
        let returnObj = { arr: arr, color: seriesObj }
        return returnObj
    }

    const organiseEquipmentDowntimeData = (bufferArr) => {
        bufferArr = _.cloneDeep(bufferArr);
        bufferArr = aggreagteEquipmentDowntime(bufferArr)
        let schema = ['Equipment']
        let arr = [];
        let colorWithReason = []
        let seriesObj = {}
        bufferArr.forEach(element => {
            element.Downtime.forEach((one, i) => {
                let IsAlready;
                let obj = {}

                if (one.DowntimeReason) {

                    IsAlready = schema.includes(one.DowntimeReason);
                } else {

                    IsAlready = schema.includes(one.State);
                }
                if (!IsAlready) {
                    if (one.DowntimeReason) {
                        obj.Reason = one.DowntimeReason;
                        obj.Color = one.Color;
                        colorWithReason.push(obj)
                        schema.push(one.DowntimeReason)
                        schema.push({ role: 'style' })
                    } else {
                        obj.Reason = one.State;
                        obj.Color = 'red';
                        colorWithReason.push(obj)
                        schema.push(one.State)
                        schema.push({ role: 'style' })
                    }
                }
            })
        });

        bufferArr.forEach(element => {
            let oneArr = []
            if (element.Downtime.length > 0) {
                oneArr = [element.Equipment]
            }
            let down = element.Downtime;
            if (down.length > 0) {
                down = aggreagteReasonDowntime(down)
                for (let i = 1; i < schema.length; i = i + 2) {
                    let filterDown = down.filter((one) => {
                        if (one.DowntimeReason) {
                            if (one.DowntimeReason == schema[i]) {
                                return one
                            }
                        } else {
                            if (one.State == schema[i]) {
                                return one
                            }
                        }
                    }
                    )
                    if (filterDown.length > 0) {
                        oneArr.push(Math.ceil(filterDown[0].Duration));
                        oneArr.push(filterDown[0].Color)
                    } else {
                        let filterColor = colorWithReason.filter(color => color.Reason == schema[i])
                        oneArr.push(0);
                        oneArr.push(filterColor[0].Color)
                    }
                }
                arr.push(oneArr)
            }

        })
        arr.unshift(schema)
        colorWithReason.forEach((one, i) => {
            seriesObj[i] = { color: one.Color }
        })
        let returnObj = { arr: arr, color: seriesObj }
        return returnObj
    }


    const qualityColorAssign = (bufferArr) => {
        let startIdx = 0
        bufferArr.forEach((obj) => {
            obj.RejectionReason.forEach((reason) => {
                if (colors[startIdx]) {
                    reason.Color = colors[startIdx].hex;
                    startIdx = startIdx + 1;
                } else {
                    reason.Color = colors[0].hex;
                    startIdx = 1;
                }

            })
        })
        return bufferArr;
    }

    const organiseRejectionData = (bufferArr) => {
        bufferArr = [...getComponentUniqe(bufferArr)]
        bufferArr = qualityColorAssign(bufferArr);
        let schema = ['Component/Operation']
        let arr = [];
        let colorWithReason = []
        let seriesObj = {}
        bufferArr.forEach(element => {
            element.RejectionReason.forEach((one, i) => {
                let IsAlready;
                let obj = {}
                if (one.Reason) {
                    IsAlready = schema.includes(one.Reason);
                } else {
                    IsAlready = schema.includes(one.Reason);
                }
                if (!IsAlready) {
                    if (one.Reason) {
                        obj.Reason = one.Reason;
                        obj.Color = one.Color;
                        colorWithReason.push(obj)
                        schema.push(one.Reason)
                        schema.push({ role: 'style' })
                    } else {
                        obj.Reason = one.Reason;
                        obj.Color = 'red';
                        colorWithReason.push(obj)
                        schema.push(one.Reason)
                        schema.push({ role: 'style' })
                    }
                }
            })
        });

        bufferArr.forEach(element => {
            let oneArr = []
            if (element.RejectionReason.length > 0) {
                oneArr = [element.Component + "/" + element.Operation]
            }
            let down = element.RejectionReason;
            if (down.length > 0) {
                // down = aggreagteReasonDowntime(down)
                for (let i = 1; i < schema.length; i = i + 2) {
                    let filterDown = down.filter((one) => {
                        if (one.Reason) {
                            if (one.Reason == schema[i]) {
                                return one
                            }
                        } else {
                            if (one.Reason == schema[i]) {
                                return one
                            }
                        }
                    }
                    )
                    if (filterDown.length > 0) {
                        oneArr.push(Math.ceil(filterDown[0].Count));
                        oneArr.push(filterDown[0].Color)
                    } else {
                        let filterColor = colorWithReason.filter(color => color.Reason == schema[i])
                        oneArr.push(0);
                        oneArr.push(filterColor[0].Color)
                    }
                }
                arr.push(oneArr)
            }

        })
        arr.unshift(schema)
        colorWithReason.forEach((one, i) => {
            seriesObj[i] = { color: one.Color }
        })
        let returnObj = { arr: arr, color: seriesObj }
        return returnObj
    }

    function aggreagteReasonDowntime(bufferArry) {
        bufferArry = [...bufferArry]
        for (let i = 0; i < bufferArry.length; i++) {
            for (let j = i + 1; j < bufferArry.length; j++) {
                if (bufferArry[i].DowntimeReason === bufferArry[j].DowntimeReason) {
                    bufferArry[i].Duration += bufferArry[j].Duration
                    bufferArry.splice(j, 1);

                    // i--;
                    j--;
                    // i=j-1
                }
            }
        }
        return bufferArry
    }

    function aggreagteRejectionCount(bufferArry) {

        for (let i = 0; i < bufferArry.length; i++) {
            for (let j = i + 1; j < bufferArry.length; j++) {
                if (bufferArry[i].Reason === bufferArry[j].Reason) {
                    bufferArry[i].Count += bufferArry[j].Count
                    bufferArry.splice(j, 1);

                    // i--;
                    j--;
                    // i=j-1
                }
            }
        }
        return bufferArry
    }

    function aggreagteEquipmentDowntime(bufferArry) {
        bufferArry = [...bufferArry]
        for (let i = 0; i < bufferArry.length; i++) {
            for (let j = i + 1; j < bufferArry.length; j++) {
                if (bufferArry[i].Equipment === bufferArry[j].Equipment) {
                    bufferArry[i].Downtime = [...bufferArry[j].Downtime, ...bufferArry[i].Downtime]
                    bufferArry.splice(j, 1);
                    j--;
                }
            }
        }
        bufferArry.forEach((one) => {
            one.Downtime = aggreagteReasonDowntime(one.Downtime);
        })
        return bufferArry
    }

    const addPeriodicity = (bufferArry) => {
        bufferArry = [...bufferArry];

        if (inputData.Periodicity == 'Weekly') {
            let frames = dateTime.GetWeeklyFrame(new Date(inputData.From), new Date(inputData.Till))
            frames.forEach((one) => {
                one.From.setHours(0, 0, 0, 0);
                one.Till.setHours(23, 59, 59, 999);
            })
            frames.forEach((one, index) => {
                bufferArry.forEach((obj) => {
                    if ((one.From <= new Date(obj.From)) && (one.Till >= new Date(obj.Till))) {
                        obj.Periodicity = one.Periodicity
                        obj.FromPeriodicity = one.From
                        obj.TillPeriodicity = one.Till
                    }
                })
            })
            return bufferArry;
        }
        else if (inputData.Periodicity == 'Daily') {
            let frames = dateTime.GetDailyFrames(new Date(inputData.From), new Date(inputData.Till))
            frames.forEach((one, index) => {
                one.From.setHours(0, 0, 0, 0);
                one.Till.setHours(23, 59, 59, 999);
            })
            frames.forEach((one, index) => {
                bufferArry.forEach((obj) => {
                    if ((one.From <= new Date(obj.From)) && (one.Till >= new Date(obj.Till))) {
                        obj.Periodicity = one.Periodicity
                        obj.FromPeriodicity = one.From
                        obj.TillPeriodicity = one.Till
                    }
                })
            })
            return bufferArry;
        } else {
            return bufferArry
        }
    }

    const getComponentUniqe = (bufferArry) => {
        bufferArry = _.cloneDeep(bufferArry);
        bufferArry.forEach((one) => {
            one.IdealSPM_x_EquipmentRunTime = (parseFloat(one.IdealSPM)*parseFloat(one.EquipmentRunTime))
        })
        if (inputData.Periodicity == 'Cummulative') {
            bufferArry.forEach((one) => {
                one.IdealSPM_x_EquipmentRunTime = (parseFloat(one.IdealSPM)*parseFloat(one.EquipmentRunTime))
                one.Periodicity = one.Shift
                one.FromPeriodicity = one.From
                one.TillPeriodicity = one.Till
                one.Performance_x_PlannedProdTime = (parseFloat(one.Performance) * parseFloat(one.PlannedProdTime))
            })
            for (let i = 0; i < bufferArry.length; i++) {
                for (let j = i + 1; j < bufferArry.length; j++) {
                    if ((bufferArry[i].Component === bufferArry[j].Component) && (bufferArry[i].Operation === bufferArry[j].Operation)) {
                        bufferArry[i].Duration += bufferArry[j].Duration;
                        bufferArry[i].IdealSPM_x_EquipmentRunTime = parseFloat(bufferArry[i].IdealSPM_x_EquipmentRunTime) + parseFloat(bufferArry[j].IdealSPM_x_EquipmentRunTime);
                        bufferArry[i].TotalRejection = parseFloat(bufferArry[i].TotalRejection) + parseFloat(bufferArry[j].TotalRejection);
                        bufferArry[i].CyclesRun = parseFloat(bufferArry[i].CyclesRun) + parseFloat(bufferArry[j].CyclesRun);
                        bufferArry[i].TotalDowntimeDuration = parseFloat(bufferArry[i].TotalDowntimeDuration) + parseFloat(bufferArry[j].TotalDowntimeDuration);
                        bufferArry[i].UnplannedDowntimeDuration = parseFloat(bufferArry[i].UnplannedDowntimeDuration) + parseFloat(bufferArry[j].UnplannedDowntimeDuration);
                        bufferArry[i].TargetParts = parseFloat(bufferArry[i].TargetParts) + parseFloat(bufferArry[j].TargetParts);
                        bufferArry[i].BreakDuration = parseFloat(bufferArry[i].BreakDuration) + parseFloat(bufferArry[j].BreakDuration);
                        bufferArry[i].JobDuration = parseFloat(bufferArry[i].JobDuration) + parseFloat(bufferArry[j].JobDuration);
                        bufferArry[i].EquipmentRunTime = parseFloat(bufferArry[i].EquipmentRunTime) + parseFloat(bufferArry[j].EquipmentRunTime);
                        bufferArry[i].PlannedProdTime = parseFloat(bufferArry[i].PlannedProdTime) + parseFloat(bufferArry[j].PlannedProdTime);
                        bufferArry[i].PlannedDowntimeDuration = parseFloat(bufferArry[i].PlannedDowntimeDuration) + parseFloat(bufferArry[j].PlannedDowntimeDuration);
                        bufferArry[i].AcceptedParts = parseInt(bufferArry[i].AcceptedParts) + parseInt(bufferArry[j].AcceptedParts);
                        bufferArry[i].PartsProduced = parseInt(bufferArry[i].PartsProduced) + parseInt(bufferArry[j].PartsProduced);
                        bufferArry[i].Performance_x_PlannedProdTime = parseFloat(bufferArry[i].Performance_x_PlannedProdTime) + parseFloat(bufferArry[j].Performance_x_PlannedProdTime);
                        bufferArry[i].RejectionReason = [...bufferArry[i].RejectionReason, ...bufferArry[j].RejectionReason];
                        bufferArry[i].Downtime = [...bufferArry[i].Downtime, ...bufferArry[j].Downtime];
                        bufferArry.splice(j, 1);
                        j--;
                    }
                }
            }
            bufferArry.forEach((one) => {
                one.Downtime = aggreagteReasonDowntime(one.Downtime);
            })
            bufferArry.forEach((one) => {
                one.RejectionReason = aggreagteRejectionCount(one.RejectionReason);
            })
            bufferArry = addPeriodicity(bufferArry);
            return bufferArry;
        }
        else if (inputData.Periodicity == 'Daily') {
            bufferArry.forEach((one) => {
                one.Performance_x_PlannedProdTime = (parseFloat(one.Performance) * parseFloat(one.PlannedProdTime))
            })
            for (let i = 0; i < bufferArry.length; i++) {
                for (let j = i + 1; j < bufferArry.length; j++) {
                    if ((bufferArry[i].ShiftOf === bufferArry[j].ShiftOf) && (bufferArry[i].Component === bufferArry[j].Component) && (bufferArry[i].Operation === bufferArry[j].Operation)) {
                        bufferArry[i].Duration += bufferArry[j].Duration;
                        bufferArry[i].IdealSPM_x_EquipmentRunTime = parseFloat(bufferArry[i].IdealSPM_x_EquipmentRunTime) + parseFloat(bufferArry[j].IdealSPM_x_EquipmentRunTime);
                        bufferArry[i].TotalRejection = parseFloat(bufferArry[i].TotalRejection) + parseFloat(bufferArry[j].TotalRejection);
                        bufferArry[i].CyclesRun = parseFloat(bufferArry[i].CyclesRun) + parseFloat(bufferArry[j].CyclesRun);
                        bufferArry[i].TotalDowntimeDuration = parseFloat(bufferArry[i].TotalDowntimeDuration) + parseFloat(bufferArry[j].TotalDowntimeDuration);
                        bufferArry[i].UnplannedDowntimeDuration = parseFloat(bufferArry[i].UnplannedDowntimeDuration) + parseFloat(bufferArry[j].UnplannedDowntimeDuration);
                        bufferArry[i].TargetParts = parseFloat(bufferArry[i].TargetParts) + parseFloat(bufferArry[j].TargetParts);
                        bufferArry[i].BreakDuration = parseFloat(bufferArry[i].BreakDuration) + parseFloat(bufferArry[j].BreakDuration);
                        bufferArry[i].JobDuration = parseFloat(bufferArry[i].JobDuration) + parseFloat(bufferArry[j].JobDuration);
                        bufferArry[i].EquipmentRunTime = parseFloat(bufferArry[i].EquipmentRunTime) + parseFloat(bufferArry[j].EquipmentRunTime);
                        bufferArry[i].PlannedProdTime = parseFloat(bufferArry[i].PlannedProdTime) + parseFloat(bufferArry[j].PlannedProdTime);
                        bufferArry[i].PlannedDowntimeDuration = parseFloat(bufferArry[i].PlannedDowntimeDuration) + parseFloat(bufferArry[j].PlannedDowntimeDuration);
                        bufferArry[i].AcceptedParts = parseInt(bufferArry[i].AcceptedParts) + parseInt(bufferArry[j].AcceptedParts);
                        bufferArry[i].PartsProduced = parseInt(bufferArry[i].PartsProduced) + parseInt(bufferArry[j].PartsProduced);
                        bufferArry[i].Performance_x_PlannedProdTime = parseFloat(bufferArry[i].Performance_x_PlannedProdTime) + parseFloat(bufferArry[j].Performance_x_PlannedProdTime);
                        bufferArry[i].RejectionReason = [...bufferArry[i].RejectionReason, ...bufferArry[j].RejectionReason];
                        bufferArry[i].Downtime = [...bufferArry[i].Downtime, ...bufferArry[j].Downtime];
                        bufferArry.splice(j, 1);
                        j--;
                    }

                }
            }
            bufferArry.forEach((one) => {
                one.Downtime = aggreagteReasonDowntime(one.Downtime);
            })
            bufferArry.forEach((one) => {
                one.RejectionReason = aggreagteRejectionCount(one.RejectionReason);
            })
            bufferArry = addPeriodicity(bufferArry);
            return bufferArry;
        }
        else if (inputData.Periodicity == 'Weekly') {
            bufferArry.forEach((one) => {
                one.Performance_x_PlannedProdTime = (parseFloat(one.Performance) * parseFloat(one.PlannedProdTime))
            })
            for (let i = 0; i < bufferArry.length; i++) {
                let start
                for (let j = i + 1; j < bufferArry.length; j++) {
                    if (dateTime.IsInSameWeek(new Date(bufferArry[i].ShiftOf), new Date(bufferArry[j].ShiftOf)) && (bufferArry[i].Component === bufferArry[j].Component) && (bufferArry[i].Operation === bufferArry[j].Operation)) {
                        bufferArry[i].Duration += bufferArry[j].Duration;
                        bufferArry[i].IdealSPM_x_EquipmentRunTime = parseFloat(bufferArry[i].IdealSPM_x_EquipmentRunTime) + parseFloat(bufferArry[j].IdealSPM_x_EquipmentRunTime);
                        bufferArry[i].TotalRejection = parseFloat(bufferArry[i].TotalRejection) + parseFloat(bufferArry[j].TotalRejection);
                        bufferArry[i].CyclesRun = parseFloat(bufferArry[i].CyclesRun) + parseFloat(bufferArry[j].CyclesRun);
                        bufferArry[i].TotalDowntimeDuration = parseFloat(bufferArry[i].TotalDowntimeDuration) + parseFloat(bufferArry[j].TotalDowntimeDuration);
                        bufferArry[i].UnplannedDowntimeDuration = parseFloat(bufferArry[i].UnplannedDowntimeDuration) + parseFloat(bufferArry[j].UnplannedDowntimeDuration);
                        bufferArry[i].TargetParts = parseFloat(bufferArry[i].TargetParts) + parseFloat(bufferArry[j].TargetParts);
                        bufferArry[i].BreakDuration = parseFloat(bufferArry[i].BreakDuration) + parseFloat(bufferArry[j].BreakDuration);
                        bufferArry[i].JobDuration = parseFloat(bufferArry[i].JobDuration) + parseFloat(bufferArry[j].JobDuration);
                        bufferArry[i].EquipmentRunTime = parseFloat(bufferArry[i].EquipmentRunTime) + parseFloat(bufferArry[j].EquipmentRunTime);
                        bufferArry[i].PlannedProdTime = parseFloat(bufferArry[i].PlannedProdTime) + parseFloat(bufferArry[j].PlannedProdTime);
                        bufferArry[i].PlannedDowntimeDuration = parseFloat(bufferArry[i].PlannedDowntimeDuration) + parseFloat(bufferArry[j].PlannedDowntimeDuration);
                        bufferArry[i].AcceptedParts = parseInt(bufferArry[i].AcceptedParts) + parseInt(bufferArry[j].AcceptedParts);
                        bufferArry[i].PartsProduced = parseInt(bufferArry[i].PartsProduced) + parseInt(bufferArry[j].PartsProduced);
                        bufferArry[i].Performance_x_PlannedProdTime = parseFloat(bufferArry[i].Performance_x_PlannedProdTime) + parseFloat(bufferArry[j].Performance_x_PlannedProdTime);
                        bufferArry[i].RejectionReason = [...bufferArry[i].RejectionReason, ...bufferArry[j].RejectionReason];
                        bufferArry[i].Downtime = [...bufferArry[i].Downtime, ...bufferArry[j].Downtime];
                        bufferArry.splice(j, 1);
                        j--;
                    }

                }
            }
            bufferArry.forEach((one) => {
                one.PlannedProdTime = parseFloat(one.PlannedProdTime).toFixed(2);
                one.Downtime = aggreagteReasonDowntime(one.Downtime);
            })
            bufferArry.forEach((one) => {
                one.RejectionReason = aggreagteRejectionCount(one.RejectionReason);
            })
            bufferArry = addPeriodicity(bufferArry);
            return bufferArry;
        }
        else if (inputData.Periodicity == 'Shift') {
            bufferArry.forEach((one) => {
                one.FromPeriodicity = one.From
                one.TillPeriodicity = one.Till
                one.Periodicity = one.Shift
                one.Performance_x_PlannedProdTime = (parseFloat(one.Performance) * parseFloat(one.PlannedProdTime))
            })
            bufferArry.forEach((one) => {
                one.Downtime = aggreagteReasonDowntime(one.Downtime);
            })
            bufferArry.forEach((one) => {
                one.RejectionReason = aggreagteRejectionCount(one.RejectionReason);
            })
            bufferArry = addPeriodicity(bufferArry);
            return bufferArry;
        } else {
            return []
        }

    }

    const getAPQEChart = (bufferArr) => {
        bufferArr = _.cloneDeep(bufferArr);
        const schema = [
            ["Component", "Availability", "Performance", "Quality", "OEE"],
        ];
        bufferArr = [...getComponentUniqe(bufferArr)];
        bufferArr.forEach((one) => {
            let data = []
            let avila = parseFloat(((one.EquipmentRunTime / (parseFloat(one.PlannedProdTime) - parseFloat(one.PlannedDowntimeDuration))) * 100).toPrecision(4));
            let perf = parseFloat((one.Performance_x_PlannedProdTime / parseFloat(one.PlannedProdTime)).toPrecision(4));
            let qf = parseFloat(((one.AcceptedParts / one.PartsProduced) * 100).toPrecision(4))
            let oee = parseFloat(((avila * perf * qf) / 10000).toPrecision(4))
            data.push(one.Component);
            data.push(avila);
            data.push(perf);
            data.push(qf);
            data.push(oee);
            schema.push(data);

        })

        const options = {
            chart: {
                title: "Component Wise OEE",
            },
            hAxis: {
                title: 'Percentage',
                
            },
            
            // bars: "horizontal",
        };
        return <Chart
            chartType="Bar"
            // width="100%"
            data={schema}
             height="600px"
            options={options}
        />
    }


    const getRejectionAnalysis = (bufferArr) => {
        bufferArr = _.cloneDeep(bufferArr);
        return <Chart
            // width={'100%'}
            height={800}
            style={{ padding: 0, height: 600}}
            // style={{ padding: 0, height: (bufferArr.length + 1) * 30 }}
            chartType="ColumnChart"
            loader={<div>Loading Chart</div>}
            data={organiseRejectionData(bufferArr).arr}
            options={{
                title: 'Component Wise Rejection Analysis',
                // chartArea: { width: '50%' },
                isStacked: true,
                series: organiseRejectionData(bufferArr).color,
                vAxis: {
                    title: 'Rejection Count',
                    minValue: 0,
                },
                hAxis: {
                    title: 'Component',
                   

                },

            }}
            // For tests
            rootProps={{ 'data-testid': '3' }}
        />
    }

    const getComponentWiseDowntime = (bufferArr) => {
        bufferArr = _.cloneDeep(bufferArr);
        return <Chart
            // width={'100%'}
             height={800}
             style={{ padding: 0, height: 600 }}
            chartType="ColumnChart"
            loader={<div>Loading Chart</div>}
            data={organiseDowntimeData(bufferArr).arr}
            options={{
                title: 'Component Wise Downtime Analysis',
                // chartArea: { width: '50%' },
                isStacked: true,
                series: organiseDowntimeData(bufferArr).color,
                vAxis: {
                    title: 'Downtime Duration',
                    minValue: 0,
                },
                hAxis: {
                    title: 'Component',
                   

                },
               

            }}
            // For tests
            rootProps={{ 'data-testid': '3' }}
        />
    }

    const getEquipmentWiseDowntime = (bufferArr) => {
        bufferArr = _.cloneDeep(bufferArr);
        return <Chart
            // width={'100%'}
            height={800}
            style={{ padding: 0, height: 600}}
            chartType="ColumnChart"
            loader={<div>Loading Chart</div>}
            data={organiseEquipmentDowntimeData(bufferArr).arr}
            options={{
                title: 'Equipment Wise Downtime Analysis',
                // chartArea: { width: '50%' },
                isStacked: true,
                series: organiseEquipmentDowntimeData(bufferArr).color,
                vAxis: {
                    title: 'Downtime Duration',
                    minValue: 0,
                },
                hAxis: {
                    title: 'Equipment',
                   

                },

            }}
            // For tests
            rootProps={{ 'data-testid': '3' }}
        />
    }

    const getPlantWiseAccumlate = (bufferArry) => {
        bufferArry = _.cloneDeep(bufferArry);
        bufferArry.forEach((one) => {
            one.IdealSPM_x_EquipmentRunTime = (parseFloat(one.IdealSPM)*parseFloat(one.EquipmentRunTime))
        })
        if (inputData.Periodicity == 'Cummulative') {
            bufferArry.forEach((one) => {
                one.Periodicity = one.Shift
                one.FromPeriodicity = inputData.From
                one.TillPeriodicity = inputData.Till
                one.Performance_x_PlannedProdTime = (parseFloat(one.Performance) * parseFloat(one.PlannedProdTime))
            })
            for (let i = 0; i < bufferArry.length; i++) {
                for (let j = i + 1; j < bufferArry.length; j++) {
                    bufferArry[i].Duration += bufferArry[j].Duration;
                    bufferArry[i].IdealSPM_x_EquipmentRunTime = parseFloat(bufferArry[i].IdealSPM_x_EquipmentRunTime) + parseFloat(bufferArry[j].IdealSPM_x_EquipmentRunTime);
                    bufferArry[i].TotalRejection = parseFloat(bufferArry[i].TotalRejection) + parseFloat(bufferArry[j].TotalRejection);
                    bufferArry[i].CyclesRun = parseFloat(bufferArry[i].CyclesRun) + parseFloat(bufferArry[j].CyclesRun);
                    bufferArry[i].TotalDowntimeDuration = parseFloat(bufferArry[i].TotalDowntimeDuration) + parseFloat(bufferArry[j].TotalDowntimeDuration);
                    bufferArry[i].UnplannedDowntimeDuration = parseFloat(bufferArry[i].UnplannedDowntimeDuration) + parseFloat(bufferArry[j].UnplannedDowntimeDuration);
                    bufferArry[i].TargetParts = parseFloat(bufferArry[i].TargetParts) + parseFloat(bufferArry[j].TargetParts);
                    bufferArry[i].BreakDuration = parseFloat(bufferArry[i].BreakDuration) + parseFloat(bufferArry[j].BreakDuration);
                    bufferArry[i].JobDuration = parseFloat(bufferArry[i].JobDuration) + parseFloat(bufferArry[j].JobDuration);
                    bufferArry[i].EquipmentRunTime = parseFloat(bufferArry[i].EquipmentRunTime) + parseFloat(bufferArry[j].EquipmentRunTime);
                    bufferArry[i].PlannedProdTime = parseFloat(bufferArry[i].PlannedProdTime) + parseFloat(bufferArry[j].PlannedProdTime);
                    bufferArry[i].PlannedDowntimeDuration = parseFloat(bufferArry[i].PlannedDowntimeDuration) + parseFloat(bufferArry[j].PlannedDowntimeDuration);
                    bufferArry[i].AcceptedParts = parseInt(bufferArry[i].AcceptedParts) + parseInt(bufferArry[j].AcceptedParts);
                    bufferArry[i].PartsProduced = parseInt(bufferArry[i].PartsProduced) + parseInt(bufferArry[j].PartsProduced);
                    bufferArry[i].Performance_x_PlannedProdTime = parseFloat(bufferArry[i].Performance_x_PlannedProdTime) + parseFloat(bufferArry[j].Performance_x_PlannedProdTime);
                    bufferArry[i].RejectionReason = [...bufferArry[i].RejectionReason, ...bufferArry[j].RejectionReason];
                    bufferArry[i].Downtime = [...bufferArry[i].Downtime, ...bufferArry[j].Downtime];
                    bufferArry.splice(j, 1);
                    j--;
                }
            }
            bufferArry.forEach((one) => {
                one.Downtime = aggreagteReasonDowntime(one.Downtime);
            })
            bufferArry.forEach((one) => {
                one.RejectionReason = aggreagteRejectionCount(one.RejectionReason);
            })
            bufferArry = addPeriodicity(bufferArry);
            return bufferArry;
        }
        else if (inputData.Periodicity == 'Daily') {
            bufferArry.forEach((one) => {
                one.Performance_x_PlannedProdTime = (parseFloat(one.Performance) * parseFloat(one.PlannedProdTime))
            })
            for (let i = 0; i < bufferArry.length; i++) {
                for (let j = i + 1; j < bufferArry.length; j++) {
                    if ((bufferArry[i].ShiftOf === bufferArry[j].ShiftOf)) {
                        bufferArry[i].Duration += bufferArry[j].Duration;
                        bufferArry[i].IdealSPM_x_EquipmentRunTime = parseFloat(bufferArry[i].IdealSPM_x_EquipmentRunTime) + parseFloat(bufferArry[j].IdealSPM_x_EquipmentRunTime);
                        bufferArry[i].TotalRejection = parseFloat(bufferArry[i].TotalRejection) + parseFloat(bufferArry[j].TotalRejection);
                        bufferArry[i].CyclesRun = parseFloat(bufferArry[i].CyclesRun) + parseFloat(bufferArry[j].CyclesRun);
                        bufferArry[i].TotalDowntimeDuration = parseFloat(bufferArry[i].TotalDowntimeDuration) + parseFloat(bufferArry[j].TotalDowntimeDuration);
                        bufferArry[i].UnplannedDowntimeDuration = parseFloat(bufferArry[i].UnplannedDowntimeDuration) + parseFloat(bufferArry[j].UnplannedDowntimeDuration);
                        bufferArry[i].TargetParts = parseFloat(bufferArry[i].TargetParts) + parseFloat(bufferArry[j].TargetParts);
                        bufferArry[i].BreakDuration = parseFloat(bufferArry[i].BreakDuration) + parseFloat(bufferArry[j].BreakDuration);
                        bufferArry[i].JobDuration = parseFloat(bufferArry[i].JobDuration) + parseFloat(bufferArry[j].JobDuration);
                        bufferArry[i].EquipmentRunTime = parseFloat(bufferArry[i].EquipmentRunTime) + parseFloat(bufferArry[j].EquipmentRunTime);
                        bufferArry[i].PlannedProdTime = parseFloat(bufferArry[i].PlannedProdTime) + parseFloat(bufferArry[j].PlannedProdTime);
                        bufferArry[i].PlannedDowntimeDuration = parseFloat(bufferArry[i].PlannedDowntimeDuration) + parseFloat(bufferArry[j].PlannedDowntimeDuration);
                        bufferArry[i].AcceptedParts = parseInt(bufferArry[i].AcceptedParts) + parseInt(bufferArry[j].AcceptedParts);
                        bufferArry[i].PartsProduced = parseInt(bufferArry[i].PartsProduced) + parseInt(bufferArry[j].PartsProduced);
                        bufferArry[i].Performance_x_PlannedProdTime = parseFloat(bufferArry[i].Performance_x_PlannedProdTime) + parseFloat(bufferArry[j].Performance_x_PlannedProdTime);
                        bufferArry[i].RejectionReason = [...bufferArry[i].RejectionReason, ...bufferArry[j].RejectionReason];
                        bufferArry[i].Downtime = [...bufferArry[i].Downtime, ...bufferArry[j].Downtime];

                        bufferArry.splice(j, 1);
                        j--;
                    }

                }
            }
            bufferArry.forEach((one) => {
                one.Downtime = aggreagteReasonDowntime(one.Downtime);
            })
            bufferArry.forEach((one) => {
                one.RejectionReason = aggreagteRejectionCount(one.RejectionReason);
            })
            bufferArry = addPeriodicity(bufferArry);
            return bufferArry;
        }
        else if (inputData.Periodicity == 'Weekly') {
            bufferArry.forEach((one) => {
                one.Performance_x_PlannedProdTime = (parseFloat(one.Performance) * parseFloat(one.PlannedProdTime))
            })
            for (let i = 0; i < bufferArry.length; i++) {
                for (let j = i + 1; j < bufferArry.length; j++) {
                    if (dateTime.IsInSameWeek(new Date(bufferArry[i].ShiftOf), new Date(bufferArry[j].ShiftOf))) {
                        bufferArry[i].Duration += bufferArry[j].Duration;
                        bufferArry[i].IdealSPM_x_EquipmentRunTime = parseFloat(bufferArry[i].IdealSPM_x_EquipmentRunTime) + parseFloat(bufferArry[j].IdealSPM_x_EquipmentRunTime);
                        bufferArry[i].TotalRejection = parseFloat(bufferArry[i].TotalRejection) + parseFloat(bufferArry[j].TotalRejection);
                        bufferArry[i].CyclesRun = parseFloat(bufferArry[i].CyclesRun) + parseFloat(bufferArry[j].CyclesRun);
                        bufferArry[i].TotalDowntimeDuration = parseFloat(bufferArry[i].TotalDowntimeDuration) + parseFloat(bufferArry[j].TotalDowntimeDuration);
                        bufferArry[i].UnplannedDowntimeDuration = parseFloat(bufferArry[i].UnplannedDowntimeDuration) + parseFloat(bufferArry[j].UnplannedDowntimeDuration);
                        bufferArry[i].TargetParts = parseFloat(bufferArry[i].TargetParts) + parseFloat(bufferArry[j].TargetParts);
                        bufferArry[i].BreakDuration = parseFloat(bufferArry[i].BreakDuration) + parseFloat(bufferArry[j].BreakDuration);
                        bufferArry[i].JobDuration = parseFloat(bufferArry[i].JobDuration) + parseFloat(bufferArry[j].JobDuration);
                        bufferArry[i].EquipmentRunTime = parseFloat(bufferArry[i].EquipmentRunTime) + parseFloat(bufferArry[j].EquipmentRunTime);
                        bufferArry[i].PlannedProdTime = parseFloat(bufferArry[i].PlannedProdTime) + parseFloat(bufferArry[j].PlannedProdTime);
                        bufferArry[i].PlannedDowntimeDuration = parseFloat(bufferArry[i].PlannedDowntimeDuration) + parseFloat(bufferArry[j].PlannedDowntimeDuration);
                        bufferArry[i].AcceptedParts = parseInt(bufferArry[i].AcceptedParts) + parseInt(bufferArry[j].AcceptedParts);
                        bufferArry[i].PartsProduced = parseInt(bufferArry[i].PartsProduced) + parseInt(bufferArry[j].PartsProduced);
                        bufferArry[i].Performance_x_PlannedProdTime = parseFloat(bufferArry[i].Performance_x_PlannedProdTime) + parseFloat(bufferArry[j].Performance_x_PlannedProdTime);
                        bufferArry[i].RejectionReason = [...bufferArry[i].RejectionReason, ...bufferArry[j].RejectionReason];
                        bufferArry[i].Downtime = [...bufferArry[i].Downtime, ...bufferArry[j].Downtime];
                        bufferArry.splice(j, 1);
                        j--;
                    }

                }
            }
            bufferArry.forEach((one) => {
                one.Downtime = aggreagteReasonDowntime(one.Downtime);
            })
            bufferArry.forEach((one) => {
                one.RejectionReason = aggreagteRejectionCount(one.RejectionReason);
            })
            bufferArry = addPeriodicity(bufferArry);
            return bufferArry;
        }
        else if (inputData.Periodicity == 'Shift') {
            bufferArry.forEach((one) => {
                one.FromPeriodicity = one.From
                one.TillPeriodicity = one.Till
                one.Periodicity = one.Shift
                one.Performance_x_PlannedProdTime = (parseFloat(one.Performance) * parseFloat(one.PlannedProdTime))
            })
            for (let i = 0; i < bufferArry.length; i++) {
                for (let j = i + 1; j < bufferArry.length; j++) {
                    if ((bufferArry[i].ShiftOf === bufferArry[j].ShiftOf) && (bufferArry[i].Shift === bufferArry[j].Shift)) {
                        bufferArry[i].Duration += bufferArry[j].Duration;
                        bufferArry[i].IdealSPM_x_EquipmentRunTime = parseFloat(bufferArry[i].IdealSPM_x_EquipmentRunTime) + parseFloat(bufferArry[j].IdealSPM_x_EquipmentRunTime);
                        bufferArry[i].TotalRejection = parseFloat(bufferArry[i].TotalRejection) + parseFloat(bufferArry[j].TotalRejection);
                        bufferArry[i].CyclesRun = parseFloat(bufferArry[i].CyclesRun) + parseFloat(bufferArry[j].CyclesRun);
                        bufferArry[i].TotalDowntimeDuration = parseFloat(bufferArry[i].TotalDowntimeDuration) + parseFloat(bufferArry[j].TotalDowntimeDuration);
                        bufferArry[i].UnplannedDowntimeDuration = parseFloat(bufferArry[i].UnplannedDowntimeDuration) + parseFloat(bufferArry[j].UnplannedDowntimeDuration);
                        bufferArry[i].TargetParts = parseFloat(bufferArry[i].TargetParts) + parseFloat(bufferArry[j].TargetParts);
                        bufferArry[i].BreakDuration = parseFloat(bufferArry[i].BreakDuration) + parseFloat(bufferArry[j].BreakDuration);
                        bufferArry[i].JobDuration = parseFloat(bufferArry[i].JobDuration) + parseFloat(bufferArry[j].JobDuration);
                        bufferArry[i].EquipmentRunTime = parseFloat(bufferArry[i].EquipmentRunTime) + parseFloat(bufferArry[j].EquipmentRunTime);
                        bufferArry[i].PlannedProdTime = parseFloat(bufferArry[i].PlannedProdTime) + parseFloat(bufferArry[j].PlannedProdTime);
                        bufferArry[i].PlannedDowntimeDuration = parseFloat(bufferArry[i].PlannedDowntimeDuration) + parseFloat(bufferArry[j].PlannedDowntimeDuration);
                        bufferArry[i].AcceptedParts = parseInt(bufferArry[i].AcceptedParts) + parseInt(bufferArry[j].AcceptedParts);
                        bufferArry[i].PartsProduced = parseInt(bufferArry[i].PartsProduced) + parseInt(bufferArry[j].PartsProduced);
                        bufferArry[i].Performance_x_PlannedProdTime = parseFloat(bufferArry[i].Performance_x_PlannedProdTime) + parseFloat(bufferArry[j].Performance_x_PlannedProdTime);
                        bufferArry[i].RejectionReason = [...bufferArry[i].RejectionReason, ...bufferArry[j].RejectionReason];
                        bufferArry[i].Downtime = [...bufferArry[i].Downtime, ...bufferArry[j].Downtime];
                        bufferArry.splice(j, 1);
                        j--;
                    }

                }
            }
            bufferArry.forEach((one) => {
                one.Downtime = aggreagteReasonDowntime(one.Downtime);
            })
            bufferArry.forEach((one) => {
                one.RejectionReason = aggreagteRejectionCount(one.RejectionReason);
            })
            bufferArry = addPeriodicity(bufferArry);
            return bufferArry;
        } else {
            return []
        }

    }

    const getPlantWiseOee = (bufferArr) => {
        const schema = [
            ["Date", "Availability","Performance","QualityFactor","OEE"],
        ];
        bufferArr = getPlantWiseAccumlate(bufferArr);
        bufferArr.forEach((one) => {
            let data = []
            let avila = parseFloat(((one.EquipmentRunTime / (parseFloat(one.PlannedProdTime) - parseFloat(one.PlannedDowntimeDuration))) * 100).toPrecision(4));
            let perf = parseFloat((one.Performance_x_PlannedProdTime / parseFloat(one.PlannedProdTime)).toPrecision(4));
            let qf = parseFloat(((one.AcceptedParts / one.PartsProduced) * 100).toPrecision(4))
            let oee = parseFloat(((avila * perf * qf) / 10000).toPrecision(4))
            if (inputData.Periodicity == "Weekly" || inputData.Periodicity == "Daily") {
                data.push(dateTime.getDateFormat(one.TillPeriodicity) + "-" + dateTime.getDateFormat(one.FromPeriodicity));
            }
            if (inputData.Periodicity == "Cummulative") {
                data.push(dateTime.getDateFormat(inputData.From) + "-" + dateTime.getDateFormat(inputData.Till));
            } else {
                data.push(one.Shift + "-" + dateTime.getDateFormat(one.ShiftOf));
            }

            data.push(avila);
            data.push(perf);
            data.push(qf);
            data.push(oee);
            schema.push(data);

        })

        const options = {
            chart: {
                title: "Plant Wise OEE",
            },
            hAxis: {
                title: 'Percentage',
            },

        };
        return <Chart
            chartType="Bar"
            width="100%"
            height="800px"
            data={schema}
            options={options}
        />
    }


    const charts = {
        ComponentWiseDowntimeAnalysis: getComponentWiseDowntime([...data]),
        ComponentWiseAPQE: getAPQEChart([...data]),
        ComponentWiseRejectionAnalysis: getRejectionAnalysis([...data]),
        EquipmentWiseDowntimeAnalysis: getEquipmentWiseDowntime([...data])
    }



    const showChart = (chartType) => {

        return <Modal
            className='detail-modal report-analysis-page'
            backdrop={'static'}
            show={showChartState}
            size='xl'
            onHide={() => setShowChartState(false)}
        >
            <Modal.Header>
                <Modal.Title>
                    <p> {showChartType.label}</p>
                </Modal.Title>
                <div className="report-action-row report-modal-close-row"><button type="button" className="report-action report-action-neutral" aria-label="Close" onClick={() => setShowChartState(false)}>×</button></div>
            </Modal.Header>
            <Modal.Body>
                {charts[chartType]}
            </Modal.Body>
        </Modal>
    }



    return (
        <>
            <style>{`
                .report-analysis-page .report-action-row { display: flex !important; flex-wrap: wrap !important; align-items: center !important; gap: 12px !important; min-height: 48px !important; margin: 0 !important; padding: 4px 0 !important; max-width: 100%; box-sizing: border-box; }
                .report-analysis-page .report-action { display: inline-flex !important; align-items: center !important; justify-content: center !important; box-sizing: border-box; min-width: 96px; min-height: 36px !important; margin: 0 !important; border: 1px solid transparent !important; border-radius: 6px; padding: 8px 18px !important; color: #fff !important; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px; font-weight: 600; line-height: 18px; text-decoration: none !important; white-space: nowrap; cursor: pointer; transition: transform .15s ease, box-shadow .15s ease, opacity .15s ease; }
                .report-analysis-page .report-action-excel,
                .report-analysis-page .report-action-detail,
                .report-analysis-page .report-action-analysis,
                .report-analysis-page .report-action-email { min-width: 108px !important; }
                .report-analysis-page .report-action-neutral { min-width: 84px !important; }
                .report-analysis-page .report-action:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 4px 10px rgba(15,32,39,.18); }
                .report-analysis-page .report-action:focus-visible { outline: 2px solid #93c5fd; outline-offset: 2px; }
                .report-analysis-page .report-action:disabled,
                .report-analysis-page .report-action[aria-disabled='true'] { cursor: not-allowed; opacity: .55; transform: none; box-shadow: none; }
                .report-analysis-page .report-action-row > p { display: none; margin: 0 !important; padding: 0 !important; }
                .report-analysis-page .report-action-primary { background: linear-gradient(135deg, #0f2027, #2c5364) !important; box-shadow: 0 2px 6px rgba(15,32,39,.25); }
                .report-analysis-page .report-action-excel { background: linear-gradient(135deg, #198754, #20c997) !important; box-shadow: 0 2px 6px rgba(25,135,84,.25); }
                .report-analysis-page .report-action-detail { background: linear-gradient(135deg, #2563eb, #3b82f6) !important; box-shadow: 0 2px 6px rgba(37,99,235,.2); }
                .report-analysis-page .report-action-analysis { background: linear-gradient(135deg, #7c3aed, #a855f7) !important; box-shadow: 0 2px 6px rgba(124,58,237,.2); }
                .report-analysis-page .report-action-email { background: linear-gradient(135deg, #2563eb, #3b82f6) !important; box-shadow: 0 2px 6px rgba(37,99,235,.2); }
                .report-analysis-page .report-action-neutral { background: #fff !important; border-color: #94a3b8 !important; color: #334155 !important; }
                .report-analysis-page .report-modal-close-row { justify-content: flex-end; }
            `}</style>
            {/* {showChart(showChartType.name)} */}
            <Modal
                className='detail-modal report-analysis-page'
                backdrop={'static'}
                show={state}
                size='xl'
                onHide={onHide}
                // dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header className='m-0 p-0'>
                    <Row style={{ width: '100%' }}>
                        <div className='col-sm-4'>
                            <div style={{ background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6aa0 50%, #4a90d9 100%)', borderRadius: 12, padding: '18px 28px', marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 15px rgba(30,58,95,0.3)' }}>
                                <h4 style={{ color: '#fff', margin: 0, fontSize: 22, fontWeight: 700, letterSpacing: 0.5 }}>Detailed Production Analysis</h4>
                            </div>
                        </div>
                        <div className='col-sm-2 mt-1'>
                            <select value={inputData.ReportType?inputData.ReportType:''} name='ReportType' onChange={handleOnChnage} className='form-control form-control-sm'>
                                <option>--select option--</option>
                                <option value={"ComponentWise"}>Component Wise</option>
                                <option value={"PlantWise"}>Plant Wise</option>
                            </select>
                        </div>

                        <div className='col-sm-2'>
                            <div className="report-action-row">
                                <span onClick={() => handleDownloadTableToExcel(inputData.ReportType == 'PlantWise' ? "DetailedProductionAnalysisPlant" : "DetailedProductionAnalysisComp")} className='report-action report-action-excel'>Download Table</span>
                            </div>
                        </div>

                        {/* <div className='col-sm-2 mt-1'>
                            <select value={showChartType.name} name='ChartType' onChange={onChange} className='form-control form-control-sm'>
                                <option>--select Chart--</option>
                                <option value={"ComponentWiseDowntimeAnalysis"}>Component Wise Downtime Analysis</option>
                                <option value={"ComponentWiseAPQE"}>Component Wise APQE</option>
                                <option value={"ComponentWiseRejectionAnalysis"}>Component Wise Rejection Analysis</option>
                                <option value={"EquipmentWiseDowntimeAnalysis"}>Equipment Wise Downtime Analysis</option>
                            </select>
                        </div>
                        <div className='col-sm-2 mt-1'>
                            <span onClick={() => setShowChartState(true)} className='report-action report-action-analysis'>Generate Chart</span>
                        </div> */}




                    </Row>
                    <div className="report-action-row report-modal-close-row"><button type="button" className="report-action report-action-neutral" aria-label="Close" onClick={onHide}>×</button></div>
                </Modal.Header>
                <Modal.Body style={{ background: '#f4f6f9', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
                    <div style={{ background: '#fff', border: '1px solid #e0e6ed', borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', padding: '16px 20px', marginBottom: 12 }}>
                    <Row className="align-items-end">
                        <EquipmentSelection labelStyle={{ fontSize: 11, fontWeight: 600, color: '#5a6a85', textTransform: 'uppercase', letterSpacing: '.4px' }} style={{height:'90vh',overflowY:'auto'}} equipGroups={equipGroups} equip={equip} selectedEquipGroupOption={selectedEquipGroupOption} selectedEquipOption={selectedEquipOption} setSelection={setSelection} />
                        <div className="col-sm-2">
                            <div className="form-group text-center">
                                <label className='small' style={{ fontSize: 11, fontWeight: 600, color: '#5a6a85', textTransform: 'uppercase', letterSpacing: '.4px' }}>From</label>
                                <input value={inputData.From?inputData.From:''} min={fromDateLimit} className={'form-control form-control-sm'} onChange={handleOnChnage} placeholder='dd/mm/yyyy' type='date' name='From' />
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <div className="form-group text-center">
                                <label className='small' style={{ fontSize: 11, fontWeight: 600, color: '#5a6a85', textTransform: 'uppercase', letterSpacing: '.4px' }}>Till</label>
                                <input className='form-control form-control-sm' value={inputData.Till?inputData.Till:''} onChange={handleOnChnage} type='date' placeholder='dd/mm/yyyy' name='Till' />
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <div className="form-group text-center">
                                <label className='small' style={{ fontSize: 11, fontWeight: 600, color: '#5a6a85', textTransform: 'uppercase', letterSpacing: '.4px' }}>Shift</label>
                                <MultiSelectCheckBox name='Shift' onChange={handleOnChnage} selectedValues={inputData['Shift']} options={shiftOption} />
                                {/* {errors.Shift && <p className='text-danger ' style={{ fontSize: 11 }}>{errors.Shift}</p>} */}
                            </div>
                        </div>
                        <div className="col-sm-1">
                            <div className="form-group text-center">
                                <label value={inputData.Periodicity?inputData.Periodicity:''} className='small'>Periodicity</label>
                                <select onChange={handleOnChnage} name='Periodicity' className='form-control form-control-sm'>
                                    <option>--select report type--</option>
                                    <option value={"Shift"}>Shift Wise</option>
                                    <option value={"Daily"}>Daily</option>
                                    <option value={"Weekly"}>Weekly</option>
                                    <option value={"Cummulative"}>Cummulative</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-1">
                            <div className="report-action-row">
                                <span onClick={onApply} className='report-action report-action-primary'>Apply</span>
                            </div>
                        </div>
                    </Row>
                    </div>
                    {inputData.ReportType == "ComponentWise" ? <>
                        <Row >
                            <div style={{ overflow: 'auto', background: '#fff', borderRadius: 10, border: '1px solid #e0e6ed', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', maxHeight: '65vh' }} className='col-sm-12'>
                                {data.length > 0 ? <DetailedProdAnalysisCompTbl id='DetailedProductionAnalysisComp' inputData={inputData} qualityReason={qualityReason} reasons={reasons} data={getComponentUniqe([...data])} /> : <div style={{ padding: '28px 16px', textAlign: 'center', color: '#6c757d' }}><div style={{ fontSize: 36, opacity: 0.35 }}>📊</div><div>No data to display</div><div style={{ fontSize: 13 }}>Select filters and click Apply.</div></div>}
                            </div>

                        </Row>
                        {data.length > 0 ?
                            <>
                                {/* <Row>
                            <div className='col-sm-6'>
                                {getComponentWiseDowntime([...data])}
                            </div>
                            <div className='col-sm-6'>
                                {getAPQEChart([...data])}
                            </div>
                        </Row>
                            <Row>
                                <div className='col-sm-6'>
                                    {getRejectionAnalysis([...data])}
                                </div>
                                <div className='col-sm-6'>
                                    {getEquipmentWiseDowntime([...data])}
                                </div>
                            </Row> */}

                            </>

                            : <div style={{ padding: '20px', textAlign: 'center', color: '#6c757d' }}>Select filters and click Apply.</div>}</>

                        :
                        inputData.ReportType == "PlantWise" ?
                            <>
                                <Row>
                                    <div style={{ overflow: 'auto', background: '#fff', borderRadius: 10, border: '1px solid #e0e6ed', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', maxHeight: '65vh' }} className='col-sm-12'>
                                        {data.length > 0 ? <DetailedProdAnalysisPlantTbl inputData={inputData} id='DetailedProductionAnalysisPlant' qualityReason={qualityReason} reasons={reasons} data={getPlantWiseAccumlate(data)} /> : <div style={{ padding: '28px 16px', textAlign: 'center', color: '#6c757d' }}><div style={{ fontSize: 36, opacity: 0.35 }}>📊</div><div>No data to display</div><div style={{ fontSize: 13 }}>Select filters and click Apply.</div></div>}
                                    </div>
                                </Row>
                                {/* <Row>
                                    <div style={{ overflow: 'auto', background: '#fff', borderRadius: 10, border: '1px solid #e0e6ed', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', maxHeight: '65vh' }} className='col-sm-12'>
                                        {data.length > 0 ? getPlantWiseOee(data) : <div style={{ padding: '28px 16px', textAlign: 'center', color: '#6c757d' }}><div style={{ fontSize: 36, opacity: 0.35 }}>📊</div><div>No data to display</div><div style={{ fontSize: 13 }}>Select filters and click Apply.</div></div>}
                                    </div>
                                </Row> */}

                            </>

                            :
                            <div style={{ background: '#fff', border: '1px dashed #ced4da', borderRadius: 10, padding: '32px 16px', textAlign: 'center', color: '#6c757d' }}><div style={{ fontSize: 40, opacity: 0.35 }}>📊</div><div>Please select a report and click Apply.</div></div>}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AnalysisDetailedProduction;